import { withSecurityFilter } from "components/Forms/StockMultiSelect/securityFilterParams"

// Arvopaperi filter of the income report (Sovellon #2429). The options come from the report
// itself, so every security that has a row in any section can be picked, including one that
// only paid dividends in the period.
const SECTIONS = ["sell", "buy", "dividend", "interest", "other"]

export const securityOptionsFromSummary = (summary) => {
  const seen = new Set()
  const options = []

  SECTIONS.forEach(section => {
    (summary?.[section] || []).forEach(row => {
      if (row?.related_model_type == null || row?.related_model_id == null) {
        return
      }
      const id = `${row.related_model_type}-${row.related_model_id}`
      if (seen.has(id)) {
        return
      }
      seen.add(id)
      options.push({
        id,
        name: row?.related_model?.[0]?.name || "",
        related_model_type: row.related_model_type,
        related_model_id: row.related_model_id,
      })
    })
  })

  return options.sort((a, b) => a.name.localeCompare(b.name, "fi"))
}

// The selection travels as ?securities=type:id,... (the #2344 TransactionFilter). The old single
// select parameters are dropped so they can never narrow the report behind the user's back.
export const incomeReportSecurityParams = (params, options) => {
  const { related_model_type, related_model_id, ...rest } = params || {}
  return withSecurityFilter(rest, options)
}

// Only a report fetched without a security restriction lists every security that can be chosen;
// a restricted one would shrink the list to the current choice.
export const shouldRefreshSecurityOptions = (params) => !params?.securities
